import { createStore } from 'vuex'
import updateLocalUserSession from './plugins/updateLocalUserSession.js';

export default createStore({
    state: {
        envDev: false,
        router: {
            practiceRestart: false,
        },
        practiceModes: [
            { id: 1, type: 'phonemic-vowel', slug: 'phonemic-vowel', name: 'Ünlü Özellikleri', description: 'Bu modda Türkçedeki ünlülerin üç boyutluluk özelliklerine dair olan bilgilerini test edeceksin!' },
            { id: 2, type: 'phonetic-vowel', slug: 'phonetic-vowel', name: 'Ünlü Değişkeleri', description: 'Bu modda Türkçedeki ünlülerin değişkelerini ve onları değişke yapan ayırıcı özellik bilgilerini test edeceksin!' },
            { id: 3, type: 'phonemic-consonant', slug: 'phonemic-consonant', name: 'Ünsüz Özellikleri', description: 'Bu modda Türkçedeki ünsüzlerin üç boyutluluk özelliklerine dair olan bilgilerini test edeceksin!' },
            { id: 4, type: 'phonetic-consonant', slug: 'phonetic-consonant', name: 'Ünsüz Değişkeleri', description: 'Bu modda Türkçedeki ünsüzlerin değişkelerini ve onları değişke yapan ayırıcı özellik bilgilerini test edeceksin!' },
            { id: 5, type: 'phonetic-transcription', slug: 'phonetic-transcription', name: 'Fonetik Transkripsiyon', description: 'Bu modda IPA’yı kullanarak karşına gelen sözcüklerin transkripsiyonunu yapacaksın.' }
        ],
        selectedPracticeMode: { id: 1, type: 'phonemic-vowel', slug: 'phonemic-vowel', name: 'Ünlü Özellikleri', description: 'Bu modda Türkçedeki ünlülerin üç boyutluluk özelliklerine dair olan bilgilerini test edeceksin!' },

        api: {
            login:          process.env.VUE_APP_BASE_URL_API + 'login',
            signup:         process.env.VUE_APP_BASE_URL_API + 'signup',

            getImage:       process.env.VUE_APP_BASE_URL_API + 'image/',
            uploadImage:    process.env.VUE_APP_BASE_URL_API + `image/upload`,

            requestPasswordChange:  process.env.VUE_APP_BASE_URL_API + 'user/request-password-change',
            confirmPasswordChange:  process.env.VUE_APP_BASE_URL_API + 'user/confirm-password-change',

            requestEmailChange:     process.env.VUE_APP_BASE_URL_API + 'user/request-email-change',
            confirmEmailChange:     process.env.VUE_APP_BASE_URL_API + 'user/confirm-email-change',

            requestPasswordReset:   process.env.VUE_APP_BASE_URL_API + 'user/request-password-reset',
            confirmPasswordReset:   process.env.VUE_APP_BASE_URL_API + 'user/confirm-password-reset',

            initializePractice: process.env.VUE_APP_BASE_URL_API + 'initialize-practice',
            checkAnswer:        process.env.VUE_APP_BASE_URL_API + 'check-answer',
            skipAnswer:         process.env.VUE_APP_BASE_URL_API + 'skip-answer',
            nextQuestion:       process.env.VUE_APP_BASE_URL_API + 'next-question',
            practiceLeave:      process.env.VUE_APP_BASE_URL_API + 'practice/leave',

            analyticsPracticeStreak:                    process.env.VUE_APP_BASE_URL_API + 'analytics/practice/streak',
            analyticsPracticeNumPracticeComparative:    process.env.VUE_APP_BASE_URL_API + 'analytics/practice/num-practice/comparative',
            analyticsPracticeNumPracticeMode:           process.env.VUE_APP_BASE_URL_API + 'analytics/practice/num-practice/mode',
            analyticsPracticeChartNumPractice:          process.env.VUE_APP_BASE_URL_API + 'analytics/practice/chart/num-practice',
            analyticsPracticeTimePracticeMode:          process.env.VUE_APP_BASE_URL_API + 'analytics/practice/time-practice/mode',
            analyticsPracticeChartTimePractice:         process.env.VUE_APP_BASE_URL_API + 'analytics/practice/chart/time-practice',

            analyticsCorrectnessCorrectnessMode:            process.env.VUE_APP_BASE_URL_API + 'analytics/correctness/correctness/mode',
            analyticsCorrectnessChartCorrectnessMode:       process.env.VUE_APP_BASE_URL_API + 'analytics/correctness/chart/correctness/mode',
            analyticsCorrectnessCorrectnessPeriodic:        process.env.VUE_APP_BASE_URL_API + 'analytics/correctness/correctness/periodic',
            analyticsCorrectnessChartCorrectnessPeriodic:   process.env.VUE_APP_BASE_URL_API + 'analytics/correctness/chart/correctness/periodic',
            analyticsCorrectnessIncorrectMode:              process.env.VUE_APP_BASE_URL_API + 'analytics/correctness/incorrect/mode',

            analyticsPerfectionProgressTotal:   process.env.VUE_APP_BASE_URL_API + 'analytics/perfection/progress/total',
            analyticsPerfectionNumDiamonds:     process.env.VUE_APP_BASE_URL_API + 'analytics/perfection/num-diamonds',
            analyticsPerfectionPhones:          process.env.VUE_APP_BASE_URL_API + 'analytics/perfection/phones',

            challengeInitialize:    process.env.VUE_APP_BASE_URL_API + 'challenge/initialize',
            challengeAccept:        process.env.VUE_APP_BASE_URL_API + 'challenge/accept',
            challengeReject:        process.env.VUE_APP_BASE_URL_API + 'challenge/reject',
            challengeLeave:         process.env.VUE_APP_BASE_URL_API + 'challenge/leave',
            challengeResolve:       process.env.VUE_APP_BASE_URL_API + 'challenge/resolve',

            challengeCheckAnswer:   process.env.VUE_APP_BASE_URL_API + 'challenge/check-answer',
            challengeSkipAnswer:    process.env.VUE_APP_BASE_URL_API + 'challenge/skip-answer',
            challengeNextQuestion:  process.env.VUE_APP_BASE_URL_API + 'challenge/next-question',

            challengeUsersActive:   process.env.VUE_APP_BASE_URL_API + 'challenge/users/active',
            challengeUserSearch:    process.env.VUE_APP_BASE_URL_API + 'challenge/user/search',
            challengeListAll:       process.env.VUE_APP_BASE_URL_API + 'challenge/list/all',
            challengeRequestAll:    process.env.VUE_APP_BASE_URL_API + 'challenge/request/all',
            challengeRecent:        process.env.VUE_APP_BASE_URL_API + 'challenge/recent',
            challengeLeaderboard:   process.env.VUE_APP_BASE_URL_API + 'challenge/leaderboard',

            img: process.env.VUE_APP_BASE_URL_API + 'img/',
        },

        jsonServer: {
            login:  `http://127.0.0.11:9050/login`,
            signup: `http://127.0.0.11:9050/signup`,

            passwordResetRequest: `http://127.0.0.11:9050/password-reset-request`,
            passwordChange: `http://127.0.0.11:9050/password-change`,
            passwordConfirmCode: `http://127.0.0.11:9050/password-confirm-code`,

            confirmPasswordReset: `http://127.0.0.11:9050/confirm-password-reset`,

            emailChangeRequest: `http://127.0.0.11:9050/email-change-request`,
            emailConfirmCode: `http://127.0.0.11:9050/email-confirm-code`,

            getActiveUsers: `http://127.0.0.11:9050/getActiveUsers`,
            searchUser:     `http://127.0.0.11:9050/searchUser`,
            getAllChallenges:     `http://127.0.0.11:9050/getAllChallenges`,
            getAllRequests: 'http://127.0.0.11:9050/getAllRequests',
            getRecentChallenges: 'http://127.0.0.11:9050/getRecentChallenges',
            initializeChallenge: 'http://127.0.0.11:9050/challenge-initialize',

            emptyArray: 'http://127.0.0.11:9050/empty-array',
            challengeListAll: 'http://127.0.0.11:9050/challenge-list-all',
            challengeUsersActive: 'http://127.0.0.11:9050/challenge-users-active',
            challengeUserSearchValid: 'http://127.0.0.11:9050/challenge-user-search-valid',
            challengeUserSearchInvOptions: 'http://127.0.0.11:9050/challenge-user-search-inv-options',
            challengeInitialize: 'http://127.0.0.11:9050/challenge-initialize',
            challengeRequestAll: 'http://127.0.0.11:9050/challenge-request-all',
            challengeAccept: 'http://127.0.0.11:9050/challenge-accept',
            challengeResolveCompleted: 'http://127.0.0.11:9050/challenge-resolve-completed',
            challengeResolveIncomplete: 'http://127.0.0.11:9050/challenge-resolve-incomplete',
            challengeLeaderboard: 'http://127.0.0.11:9050/challenge-leaderboard',

            analyticsPracticeStreakUnbroken: `http://127.0.0.11:9050/analytics-practice-streak-unbroken`,
            analyticsPracticeStreakBroken: `http://127.0.0.11:9050/analytics-practice-streak-broken`,
            analyticsNumPracticeComparative: `http://127.0.0.11:9050/analytics-num-practice-comparative`,
            analyticsNumPracticeMode: `http://127.0.0.11:9050/analytics-num-practice-mode`,
            analyticsChartNumPractice: `http://127.0.0.11:9050/analytics-chart-num-practice`,
            analyticsTimePracticeMode: `http://127.0.0.11:9050/analytics-time-practice-mode`,
            analyticsChartTimePractice: `http://127.0.0.11:9050/analytics-chart-time-practice`,

            analyticsCorrectnessMode: `http://127.0.0.11:9050/analytics-correctness-mode`,
            analyticsChartCorrectnessMode: `http://127.0.0.11:9050/analytics-chart-correctness-mode`,
            analyticsCorrectnessPeriodic: `http://127.0.0.11:9050/analytics-correctness-periodic`,
            analyticsChartCorrectnessPeriodic: `http://127.0.0.11:9050/analytics-chart-correctness-periodic`,
            analyticsIncorrects: `http://127.0.0.11:9050/analytics-incorrects`,

            analyticsPerfectionTotal: `http://127.0.0.11:9050/analytics-perfection-total`,
            analyticsNumDiamonds: `http://127.0.0.11:9050/analytics-num-diamonds`,
            analyticsPerfectionPhones: `http://127.0.0.11:9050/analytics-perfection-phones`,
        },

        input: {
            username: null,
            login: {
                loginUser: '',
                loginPass: '',

                signupUser:  '',
                signupEmail: '',
                signupPass:  '',

                passwordResetRequestEmail: '',
            },
            resetPassword: {
                passNew: '',
            },
            profile: {
                passOld: '',
                passNew: '',
                emailCode: '',
                emailNew: '',
                emailChangeCode: '',
            },
            initializePractice: {
                practiceType: 'phonemic-vowel',
            },
            challengeSelectUser: {
                username: null,
                selectedUser: {
                    id: 3,
                    username: "kral1790",
                    lastActive: 1740929751,
                    rank: 393,
                    stats: {
                        win: 15,
                        loss: 26
                    }
                },
            },
            challengeRequests: {
                selectedRequest: {
                    id: 4,
                    timestamp: 1761392419,
                    user1: {
                        id: 3,
                        username: "kral1790",
                        status: "DONE-PRACTICE",
                        rank: 393,
                        stats: {
                            win: 15,
                            loss: 26
                        }
                    }
                },
            },
        },

        response: {
            profile: {
                passwordChangeData: null,
                emailChangeRequestData: null,
                passwordChangeRequestData: null,
            },

            analyticsPractice: {
                practiceStreakData: null,
                numPracticeComparativeData: null,
                numPracticeModeData: null,
                chartNumPracticeData: null,
                timePracticeModeData: null,
                chartTimePracticeData: null,
            },
            analyticsCorrectness: {
                correctnessModeData: null,
                chartCorrectnessModeData: null,
                correctnessPeriodicData: null,
                chartCorrectnessPeriodicData: null,
                incorrectsData: null,
            },
            analyticsPerfection: {
                perfectionTotalData: null,
                numDiamondsData: null,
                perfectionPhonesData: null,
            },
            challenge: {
                recentChallenges: [],
                challengeRequests: [],
            },
            challengeSelectUser: {
                activeUserItems:   [],
                searchedUserItems: [],
            },
            challengeRequests: {
                requestItems: [],
            },
            challengeResults: {
                resultItem: null,
            },
            challengeLeaderboard: {
                leaderboardItems: null,
            },
        },

        validation: {
            minLength: {
                login: {
                    user: 3,
                    pass: 3,
                },
                resetPassword: {
                    pass: 3,
                }
            },
            maxLength: {
                login: {
                    user: 14,
                },
            },
            pattern: {
                login: {
                    user: /^[a-zıİüöçğş0-9]+$/i,
                },
            },
        },

        pattern: {
            transcriptionSegment: /^(.{1}|z̥{1})([ʰ•:]?)$/,
        },

        filtertags: {
            analyticsPractice: {
                practiceStreak: [
                    {id: 1, type: 'weekly', text: 'HAFTALIK'},
                    {id: 2, type: 'monthly', text: 'AYLIK'},
                ],
                numPracticeMode: [
                    {id: 1, type: 'weekly',  text: 'HAFTALIK'},
                    {id: 2, type: 'monthly', text: 'AYLIK'},
                    {id: 3, type: 'yearly',  text: 'YILLIK'},
                ],
                timePracticeMode: [
                    {id: 1, type: 'weekly',  text: 'HAFTALIK'},
                    {id: 2, type: 'monthly', text: 'AYLIK'},
                    {id: 3, type: 'yearly',  text: 'YILLIK'},
                ],
            },
            analyticsCorrectness: {
                correctnessMode: [
                    {id: 1, type: 'last20', text: 'SON 20'},
                    {id: 2, type: 'last100', text: 'SON 100'},
                ],
                correctnessPeriodic: [
                    {id: 1, type: 'weekly',  text: 'HAFTALIK'},
                    {id: 2, type: 'monthly', text: 'AYLIK'},
                    {id: 3, type: 'yearly',  text: 'YILLIK'},
                ],
                incorrects: [
                    {id: 1, type: 'last20', text: 'SON 20'},
                    {id: 2, type: 'last100', text: 'SON 100'},
                ]
            }
        },

        selectedFiltertag: {
            analyticsPractice: {
                practiceStreak: {id: 1, type: 'weekly', text: 'HAFTALIK'},
                numPracticeMode: {id: 1, type: 'weekly',  text: 'HAFTALIK'},
                timePracticeMode: {id: 1, type: 'weekly',  text: 'HAFTALIK'},
            },
            analyticsCorrectness: {
                correctnessMode: {id: 1, type: 'last20', text: 'SON 20'},
                correctnessPeriodic: {id: 1, type: 'weekly',  text: 'HAFTALIK'},
                incorrects: {id: 1, type: 'last20', text: 'SON 20'},
            },
        },

        userSession: {
            id: 1,
            username: 'temren',
            email: 'foneturk@gmail.com',
            dateJoin: '10 Şubat 2026',
            stats: {
                win: 2,
                loss: 8
            }
        },

        practiceSession: {
            type: 'phonetic-transcription',
            idxCurQuestion: 1,
        },
        questionSet: [],

        challengeSession: {
            id: 1,
            user1: {
                id: 1,
                username: "temren",
                status: "DONE-PRACTICE"
            },
            user2: {
                id: 3,
                username: "kral1790",
                status: "WAIT-PRACTICE"
            },
            userType: 1
        },
        challengePracticeSession: {
            idxCurQuestion: 0
        },
        challengeQuestionSet: [
            {
                type: "phonemic-vowel",
                questionObject: {
                    id: 1,
                    valuePhonemic: "a"
                },
                vowelFeatures: {
                    backness: "back",
                    height: "open",
                    roundedness: "unrounded"
                }
            },
            {
                type: "phonemic-consonant",
                questionObject: {
                    id: 1,
                    valuePhonemic: "p"
                },
                consonantFeatures: {
                    manner: "plosive",
                    place: "bilabial",
                    voicing: "voiceless"
                }
            },
            {
                type: "phonetic-vowel",
                questionObject: {
                    id: 1,
                    valuePhonemic: "a",
                    valuePhonetic: "ɑ",
                    examplePhonemic: "kar",
                    examplePhonetic: "kʰɑɣ"
                },
                vowelFeatures: {
                    variant: "postdorsal"
                }
            },
            {
                type: "phonetic-consonant",
                questionObject: {
                    id: 1,
                    valuePhonemic: "k",
                    valuePhonetic: "k",
                    examplePhonemic: "karton",
                    examplePhonetic: "kʰɑɾtɔn"
                },
                consonantFeatures: {
                    variant: "postdorsal"
                }
            }
        ],

        challengeStats: {
            correct:   0,
            incorrect: 0,
            skipped:   0
        },

        answerData: {
            transcriptionSegmental: ["ɫ","ɔ","k","ʊ","m"]
        },
        feedbackData: {
            transcriptionFull: {
                correctValue: 'ɫɔkʊm',
                answerValue: 'ɫɔkʊm',
                // answerValue:  'ɫʰɔ•c:ʊm',
                // answerValue:  '',
            },
            transcriptionSegmental: {
                correctValue: ["ɫ","ɔ","k","ʊ","m"],
                answerValue: ["ɫ","ɔ","k","ʊ","m"],
                // answerValue: ["ɫʰ","ɔ•","c:","ʊ","m"],
                // answerValue: ["","","","",""],
            }
        },
        perfectionData: {
            type: 'progress',
            previous: 15,
            current: 20,
        },
        practiceStats: {
            correct: 0,
            incorrect: 0,
            skipped: 0
        },
        idxSelectedPhoneticInput: 0,
        selectedPhoneType: 'consonants',
        transcriptionPhones: {
            vowels: [
                {id: 1,  valuePhonemic: 'a', valuePhonetic: 'ɑ', features: ['arka', 'açık', 'düz'],         numVariant: 2, variant: 'arkadil'},
                {id: 2,  valuePhonemic: 'a', valuePhonetic: 'a', features: ['arka', 'açık', 'düz'],         numVariant: 2, variant: 'öndil'},

                {id: 3,  valuePhonemic: 'e', valuePhonetic: 'e', features: ['ön', 'açık', 'düz'],           numVariant: 3, variant: 'kapalı'},
                {id: 4,  valuePhonemic: 'e', valuePhonetic: 'ɛ', features: ['ön', 'açık', 'düz'],           numVariant: 3, variant: 'açık'},
                {id: 5,  valuePhonemic: 'e', valuePhonetic: 'æ', features: ['ön', 'açık', 'düz'],           numVariant: 3, variant: 'yarı-açık'},

                {id: 6,  valuePhonemic: 'o', valuePhonetic: 'o', features: ['arka', 'açık', 'yuvarlak'],    numVariant: 2, variant: 'kapalı'},
                {id: 7,  valuePhonemic: 'o', valuePhonetic: 'ɔ', features: ['arka', 'açık', 'yuvarlak'],    numVariant: 2, variant: 'açık'},

                {id: 8,  valuePhonemic: 'ö', valuePhonetic: 'ø', features: ['ön', 'açık', 'yuvarlak'],      numVariant: 2, variant: 'kapalı'},
                {id: 9,  valuePhonemic: 'ö', valuePhonetic: 'œ', features: ['ön', 'açık', 'yuvarlak'],      numVariant: 2, variant: 'açık'},

                {id: 10, valuePhonemic: 'ı', valuePhonetic: 'ɨ', features: ['orta', 'kapalı', 'düz'],       numVariant: 1, variant: 'kapalı'},

                {id: 11, valuePhonemic: 'i', valuePhonetic: 'i', features: ['ön', 'kapalı', 'düz'],         numVariant: 2, variant: 'kapalı'},
                {id: 12, valuePhonemic: 'i', valuePhonetic: 'ɪ', features: ['ön', 'kapalı', 'düz'],         numVariant: 2, variant: 'açık'},

                {id: 13, valuePhonemic: 'u', valuePhonetic: 'u', features: ['arka', 'kapalı', 'yuvarlak'],  numVariant: 2, variant: 'kapalı'},
                {id: 14, valuePhonemic: 'u', valuePhonetic: 'ʊ', features: ['arka', 'kapalı', 'yuvarlak'],  numVariant: 2, variant: 'açık'},

                {id: 15, valuePhonemic: 'ü', valuePhonetic: 'y', features: ['ön', 'kapalı', 'yuvarlak'],    numVariant: 2, variant: 'kapalı'},
                {id: 16, valuePhonemic: 'ü', valuePhonetic: 'ʏ', features: ['ön', 'kapalı', 'yuvarlak'],    numVariant: 2, variant: 'açık'},
            ],

            consonants: [
                {id: 1,  valuePhonemic: 'p', valuePhonetic: 'p', features: ['patlamalı', 'çiftdudaksıl', 'ötümsüz'], numVariant: 2, variant: ''},
                {id: 2,  valuePhonemic: 'b', valuePhonetic: 'b', features: ['patlamalı', 'çiftdudaksıl', 'ötümlü'], numVariant: 2, variant: ''},

                {id: 3,  valuePhonemic: 't', valuePhonetic: 't', features: ['patlamalı', 'dişyuvasıl', 'ötümsüz'], numVariant: 2, variant: ''},
                {id: 4,  valuePhonemic: 'd', valuePhonetic: 'd', features: ['patlamalı', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: ''},

                {id: 5,  valuePhonemic: 'k', valuePhonetic: 'k', features: ['patlamalı', 'artdamaksıl', 'ötümsüz'], numVariant: 2, variant: 'artdamaksıl'},
                {id: 6,  valuePhonemic: 'k', valuePhonetic: 'c', features: ['patlamalı', 'artdamaksıl', 'ötümsüz'], numVariant: 2, variant: 'öndamaksıl'},

                {id: 7,  valuePhonemic: 'g', valuePhonetic: 'g', features: ['patlamalı', 'artdamaksıl', 'ötümlü'], numVariant: 2, variant: 'artdamaksıl'},
                {id: 8,  valuePhonemic: 'g', valuePhonetic: 'ɟ', features: ['patlamalı', 'artdamaksıl', 'ötümlü'], numVariant: 2, variant: 'öndamaksıl'},

                {id: 9,  valuePhonemic: 'f', valuePhonetic: 'f', features: ['sürtünücü', 'dudakdiş', 'ötümsüz'], numVariant: 1, variant: ''},

                {id: 10,  valuePhonemic: 'v', valuePhonetic: 'v', features: ['sürtünücü', 'dudakdiş', 'ötümlü'], numVariant: 2, variant: 'sürtünücü'},
                {id: 11,  valuePhonemic: 'v', valuePhonetic: 'ʋ', features: ['sürtünücü', 'dudakdiş', 'ötümlü'], numVariant: 2, variant: 'daralmalı'},

                {id: 12,  valuePhonemic: 's', valuePhonetic: 's', features: ['sürtünücü', 'dişyuvasıl', 'ötümsüz'], numVariant: 1, variant: ''},

                {id: 13,  valuePhonemic: 'z', valuePhonetic: 'z', features: ['sürtünücü', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'ötümlü'},
                {id: 14,  valuePhonemic: 'z', valuePhonetic: 'z̥', features: ['sürtünücü', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'ötümsüz'},

                {id: 15,  valuePhonemic: 'ş', valuePhonetic: 'ʃ', features: ['sürtünücü', 'artdişyuvasıl', 'ötümsüz'], numVariant: 2, variant: ''},
                {id: 16,  valuePhonemic: 'j', valuePhonetic: 'ʒ', features: ['sürtünücü', 'artdişyuvasıl', 'ötümlü'], numVariant: 2, variant: ''},

                {id: 17,  valuePhonemic: 'h', valuePhonetic: 'x', features: ['sürtünücü', 'gırtlaksıl', 'ötümsüz'], numVariant: 2, variant: 'artdamaksıl'},
                {id: 18,  valuePhonemic: 'h', valuePhonetic: 'ç', features: ['sürtünücü', 'gırtlaksıl', 'ötümsüz'], numVariant: 2, variant: 'öndamaksıl'},

                {id: 19,  valuePhonemic: 'ç', valuePhonetic: 'ʧ', features: ['afrike', 'artdişyuvasıl', 'ötümsüz'], numVariant: 2, variant: ''},
                {id: 20,  valuePhonemic: 'c', valuePhonetic: 'ʤ', features: ['afrike', 'artdişyuvasıl', 'ötümlü'], numVariant: 2, variant: ''},

                {id: 21,  valuePhonemic: 'y', valuePhonetic: 'j', features: ['daralmalı', 'öndamaksıl', 'ötümlü'], numVariant: 1, variant: ''},

                {id: 22,  valuePhonemic: 'm', valuePhonetic: 'm', features: ['genizsil', 'çiftdudaksıl', 'ötümlü'], numVariant: 2, variant: 'çiftdudaksıl'},
                {id: 23,  valuePhonemic: 'm', valuePhonetic: 'ɱ', features: ['genizsil', 'çiftdudaksıl', 'ötümlü'], numVariant: 2, variant: 'dudakdiş'},

                {id: 24,  valuePhonemic: 'n', valuePhonetic: 'n', features: ['genizsil', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'dişyuvasıl'},
                {id: 25,  valuePhonemic: 'n', valuePhonetic: 'ŋ', features: ['genizsil', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'artdamaksıl'},

                {id: 26,  valuePhonemic: 'r', valuePhonetic: 'r', features: ['çarpmalı', 'dişyuvasıl', 'ötümlü'], numVariant: 3, variant: 'çokvuruşlu'},
                {id: 27,  valuePhonemic: 'r', valuePhonetic: 'ɾ', features: ['çarpmalı', 'dişyuvasıl', 'ötümlü'], numVariant: 3, variant: 'tekvuruşlu'},
                {id: 28,  valuePhonemic: 'r', valuePhonetic: 'ɣ', features: ['çarpmalı', 'dişyuvasıl', 'ötümlü'], numVariant: 3, variant: 'sürtünücü'},

                {id: 29,  valuePhonemic: 'l', valuePhonetic: 'ɬ', features: ['yandaralmalı', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'artdamaksıl'},
                {id: 30,  valuePhonemic: 'l', valuePhonetic: 'l', features: ['yandaralmalı', 'dişyuvasıl', 'ötümlü'], numVariant: 2, variant: 'öndamaksıl'},

            ],
        },

        activeUsers: null,
        selectedUser: null,
        searchUserResults: null,

        filtertagsChallengeList: [
            { id: 1, type: 'all',       label: 'TÜMÜ'  },
            { id: 2, type: 'ongoing',   label: 'AKTİF' },
            { id: 3, type: 'completed', label: 'BİTEN' },
            { id: 4, type: 'cancelled', label: 'İPTAL' },
        ],
        selectedFiltertagChallengeList: { id: 1, type: 'all', label: 'TÜMÜ' },

        ordertagsChallengeSelectUser: [
            { id: 1, type: 'last-seen',   label: 'SON GÖRÜLME' },
            { id: 2, type: 'alphabetic',  label: 'ABECESEL'    },
            { id: 3, type: 'best-rank',   label: 'EN İYİ SIRA' },
        ],
        selectedOrdertagChallengeSelectUser: { id: 1, type: 'last-seen', label: 'SON GÖRÜLME' },

        challengeItems: null,
        challengeRequests: null,
        challengeUserItems: [],


        sfx: {
            correct:    new Audio('/correct.mp3'),
            incorrect:  new Audio('/incorrect.mp3'),
            skipped:    new Audio('/skipped.mp3'),
            complete:   new Audio('/complete.mp3'),
            swoosh:     new Audio('/swoosh-5.mp3'),
            ach: new Audio('/perfection-achievement.mp3'),
            transcriptionPhone: new Audio('/practice__transcription-phone.mp3'),

            phonemicVowela: new Audio('/phonemic-vowel-a.mp3'),
            phonemicVowele: new Audio('/phonemic-vowel-e.mp3'),
            phonemicVowelo: new Audio('/phonemic-vowel-o.mp3'),
            phonemicVowelö: new Audio('/phonemic-vowel-ö.mp3'),
            phonemicVowelı: new Audio('/phonemic-vowel-ı.mp3'),
            phonemicVoweli: new Audio('/phonemic-vowel-i.mp3'),
            phonemicVowelu: new Audio('/phonemic-vowel-u.mp3'),
            phonemicVowelü: new Audio('/phonemic-vowel-ü.mp3'),

            phonemicConsonantP: new Audio('/phonemic-consonant-p.mp3'),
            phonemicConsonantB: new Audio('/phonemic-consonant-b.mp3'),
            phonemicConsonantT: new Audio('/phonemic-consonant-t.mp3'),
            phonemicConsonantD: new Audio('/phonemic-consonant-d.mp3'),
            phonemicConsonantK: new Audio('/phonemic-consonant-k.mp3'),
            phonemicConsonantG: new Audio('/phonemic-consonant-g.mp3'),
            phonemicConsonantF: new Audio('/phonemic-consonant-f.mp3'),
            phonemicConsonantV: new Audio('/phonemic-consonant-v.mp3'),
            phonemicConsonantS: new Audio('/phonemic-consonant-s.mp3'),
            phonemicConsonantZ: new Audio('/phonemic-consonant-z.mp3'),
            phonemicConsonantŞ: new Audio('/phonemic-consonant-ş.mp3'),
            phonemicConsonantJ: new Audio('/phonemic-consonant-j.mp3'),
            phonemicConsonantÇ: new Audio('/phonemic-consonant-ç.mp3'),
            phonemicConsonantC: new Audio('/phonemic-consonant-c.mp3'),
            phonemicConsonantH: new Audio('/phonemic-consonant-h.mp3'),
            phonemicConsonantY: new Audio('/phonemic-consonant-y.mp3'),
            phonemicConsonantM: new Audio('/phonemic-consonant-m.mp3'),
            phonemicConsonantN: new Audio('/phonemic-consonant-n.mp3'),
            phonemicConsonantR: new Audio('/phonemic-consonant-r.mp3'),
            phonemicConsonantL: new Audio('/phonemic-consonant-l.mp3'),

            phoneticVowelaPostdorsal: new Audio('/phonetic-vowel-a-postdorsal.mp3'),
            phoneticVowelaPredorsal:  new Audio('/phonetic-vowel-a-predorsal.mp3'),
            phoneticVoweleClose:      new Audio('/phonetic-vowel-e-close.mp3'),
            phoneticVoweleOpen:       new Audio('/phonetic-vowel-e-open.mp3'),
            phoneticVoweleNearopen:   new Audio('/phonetic-vowel-e-nearopen.mp3'),
            phoneticVoweloClose:      new Audio('/phonetic-vowel-o-close.mp3'),
            phoneticVoweloOpen:       new Audio('/phonetic-vowel-o-open.mp3'),
            phoneticVowelöClose:      new Audio('/phonetic-vowel-ö-close.mp3'),
            phoneticVowelöOpen:       new Audio('/phonetic-vowel-ö-open.mp3'),
            phoneticVoweliClose:      new Audio('/phonetic-vowel-i-close.mp3'),
            phoneticVowelıClose:      new Audio('/phonetic-vowel-ı-close.mp3'),
            phoneticVoweliOpen:       new Audio('/phonetic-vowel-i-open.mp3'),
            phoneticVoweluClose:      new Audio('/phonetic-vowel-u-close.mp3'),
            phoneticVoweluOpen:       new Audio('/phonetic-vowel-u-open.mp3'),
            phoneticVowelüClose:      new Audio('/phonetic-vowel-ü-close.mp3'),
            phoneticVowelüOpen:       new Audio('/phonetic-vowel-ü-open.mp3'),

            phoneticConsonantKpostdorsal:  new Audio('/phonetic-consonant-k-postdorsal.mp3'),
            phoneticConsonantKpredorsal:   new Audio('/phonetic-consonant-k-predorsal.mp3'),

            phoneticConsonantGpostdorsal:  new Audio('/phonetic-consonant-g-postdorsal.mp3'),
            phoneticConsonantGpredorsal:   new Audio('/phonetic-consonant-g-predorsal.mp3'),

            phoneticConsonantVfricative:   new Audio('/phonetic-consonant-v-fricative.mp3'),
            phoneticConsonantVapproximant: new Audio('/phonetic-consonant-v-approximant.mp3'),

            phoneticConsonantZvoiced:      new Audio('/phonetic-consonant-z-voiced.mp3'),
            phoneticConsonantZdevoiced:    new Audio('/phonetic-consonant-z-devoiced.mp3'),

            phoneticConsonantHpostdorsal:  new Audio('/phonetic-consonant-h-postdorsal.mp3'),
            phoneticConsonantHpredorsal:   new Audio('/phonetic-consonant-h-predorsal.mp3'),

            phoneticConsonantMbilabial:    new Audio('/phonetic-consonant-m-bilabial.mp3'),
            phoneticConsonantMlabiodental: new Audio('/phonetic-consonant-m-labiodental.mp3'),

            phoneticConsonantNalveolar:    new Audio('/phonetic-consonant-n-alveolar.mp3'),
            phoneticConsonantNpostdorsal:  new Audio('/phonetic-consonant-n-postdorsal.mp3'),

            phoneticConsonantRtrill:       new Audio('/phonetic-consonant-r-trill.mp3'),
            phoneticConsonantRtaporflap:   new Audio('/phonetic-consonant-r-taporflap.mp3'),
            phoneticConsonantRfricative:   new Audio('/phonetic-consonant-r-fricative.mp3'),

            phoneticConsonantLpostdorsal:  new Audio('/phonetic-consonant-l-postdorsal.mp3'),
            phoneticConsonantLpredorsal:   new Audio('/phonetic-consonant-l-predorsal.mp3'),

            filterbarClick: new Audio('/filterbar-click.mp3'),
        }
    },
    getters: {
    },
    mutations: {
        
        setPracticeSession(state, practiceSession){
            state.practiceSession = practiceSession;
        },

        setQuestionSet(state, questionSet){
            state.questionSet = questionSet;
        },

        setAnswerDataSchema(state, answerDataSchema){
            state.answerData = answerDataSchema;
        },

        setAnswerDataBackness(state, answerDataBackness){
            state.answerData.vowelFeatures.backness = answerDataBackness;
        },

        setAnswerDataHeight(state, answerDataHeight){
            state.answerData.vowelFeatures.height = answerDataHeight;
        },

        setAnswerDataRoundedness(state, answerDataRoundedness){
            state.answerData.vowelFeatures.roundedness = answerDataRoundedness;
        },

        setAnswerDataPlace(state, answerDataPlace){
            state.answerData.consonantFeatures.place = answerDataPlace;
        },
        
        setAnswerDataManner(state, answerDataManner){
            state.answerData.consonantFeatures.manner = answerDataManner;
        },

        setAnswerDataVoicing(state, answerDataVoicing){
            state.answerData.consonantFeatures.voicing = answerDataVoicing
        },

        setAnswerDataVowelVariant(state, answerDataVowelVariant){
            state.answerData.vowelFeatures.variant = answerDataVowelVariant;
        },

        setAnswerDataConsonantVariant(state, answerDataConsonantVariant){
            state.answerData.consonantFeatures.variant = answerDataConsonantVariant;
        },

        setFeedbackData(state, feedbackData){
            state.feedbackData = feedbackData;
        },

        resetPracticeStats(state){
            state.practiceStats = {
                correct: 0,
                incorrect: 0,
                skipped: 0
            };
        },

        incrementPracticeStatCorrect(state){
            state.practiceStats.correct++;
        },

        incrementPracticeStatIncorrect(state){
            state.practiceStats.incorrect++;
        },

        incrementPracticeStatSkipped(state){
            state.practiceStats.skipped++;
        },

        setPracticeStats(state, stats){
            state.practiceStats = stats;
        },

        setNextQuestion(state){
            state.practiceSession.idxCurQuestion++;
        },

        setIdxCurQuestion(state, idxCurQuestion){
            state.practiceSession.idxCurQuestion = idxCurQuestion;
        },

        setInputUsername(state, username){
            state.input.username = username;
        },

        setActiveUsers(state, activeUsers){
            state.activeUsers = activeUsers;
        },

        setSelectedUser(state, selectedUser){
            state.selectedUser = selectedUser;
        },

        setSelectedFiltertag(state, filtertag){
            state.selectedFiltertag = filtertag;
        },

        setChallengeItems(state, challengeItems){
            state.challengeItems = challengeItems;
        },

        setChallengeRequests(state, challengeRequests){
            state.challengeRequests = challengeRequests;
        },

        rejectChallengeRequest(state, requestId){
            let challengeRequests = state.challengeRequests;
            
            let idxDeletableDateGroup, idxDeletableRequest;

            challengeRequests.forEach((dateGroup, idxDateGroup) => {
                console.log("DateGroup: " + idxDateGroup);
                dateGroup.requests.forEach((request, idxRequest) => {
                    if(request.id === requestId){
                        state.challengeRequests[idxDateGroup].requests[idxRequest].user2.status = 'REJECTED';
                    }
                });
            });
        },

        setChallengeSession(state, challengeSession){
            state.challengeSession = challengeSession;
        },

        setSelectedFiltertagChallengeList(state, filtertag){
            state.selectedFiltertagChallengeList = filtertag;
        },

        setInputChallengeSelectUserUsername(state, username){
            state.input.challengeSelectUser.username = username;
        },

        setSelectedOrdertagChallengeSelectUser(state, ordertag){
            state.selectedOrdertagChallengeSelectUser = ordertag;
        },

        setChallengeSelectUserActiveUserItems(state, activeUserItems){
            state.response.challengeSelectUser.activeUserItems = activeUserItems;
        },

        setChallengeSelectUserSearchedUserItems(state, searchedUserItems){
            state.response.challengeSelectUser.searchedUserItems = searchedUserItems;
        },

        setInputChallengeSelectUserSelectedUser(state, userItem){
            state.input.challengeSelectUser.selectedUser = userItem;
        },

        setChallengeSession(state, challengeSession){
            state.challengeSession = challengeSession;
        },

        setChallengePracticeSession(state, challengePracticeSession){
            state.challengePracticeSession = challengePracticeSession;
        },

        setChallengeQuestionSet(state, challengeQuestionSet){
            state.challengeQuestionSet = challengeQuestionSet;
        },

        setChallengeRequestsRequestItems(state, requestItems){
            state.response.challengeRequests.requestItems = requestItems;
        },

        setInputChallengeRequestsSelectedRequest(state, requestItem){
            state.input.challengeRequests.selectedRequest = requestItem;
        },

        setChallengeNextQuestion(state){
            state.challengePracticeSession.idxCurQuestion += 1;
        },

        incrementChallengeStatCorrect(state){
            state.challengeStats.correct += 1;
        },

        incrementChallengeStatIncorrect(state){
            state.challengeStats.incorrect += 1;
        },

        incrementChallengeStatSkipped(state){
            state.challengeStats.skipped += 1;
        },

        resetChallengeStats(state){
            state.challengeStats = {
                correct:   0,
                incorrect: 0,
                skipped:   0
            };
        },

        setChallengeResultsResultItem(state, resultItem){
            state.response.challengeResults.resultItem = resultItem;
        },

        setChallengeRecentChallenges(state, recentChallenges){
            state.response.challenge.recentChallenges = recentChallenges;
        },

        setResponseChallengeChallengeRequests(state, challengeRequests){
            state.response.challenge.challengeRequests = challengeRequests;
        },

        setResponseChallengeLeaderboardLeaderboardItems(state, leaderboardItems){
            state.response.challengeLeaderboard.leaderboardItems = leaderboardItems;
        },

        setResponseAnalyticsPracticePracticeStreakData(state, practiceStreakData){
            state.response.analyticsPractice.practiceStreakData = practiceStreakData;
        },

        setSelectedFiltertagAnalyticsPracticePracticeStreak(state, filtertag){
            state.selectedFiltertag.analyticsPractice.practiceStreak = filtertag;
        },

        setResponse(state, options){
            state.response[options.categoryLabel][options.dataLabel] = options.data;
        },

        setSelectedFiltertag(state, options){
            state.selectedFiltertag[options.categoryLabel][options.filtertagLabel] = options.filtertag;
        },

        setPerfectionData(state, perfectionData){            
            state.perfectionData = perfectionData;
        },

        setRouterPracticeRestart(state, practiceRestart){
            state.router.practiceRestart = practiceRestart;
        },

        setSelectedPracticeMode(state, selectedPracticeMode){
            state.selectedPracticeMode = selectedPracticeMode;
        },

        setInput(state, options){
            state.input[options.categoryLabel][options.dataLabel] = options.data;
        },

        setUserSession(state, userSession){
            state.userSession = userSession;
        },

        setIdxSelectedPhoneticInput(state, idx){
            state.idxSelectedPhoneticInput = idx;
        },

        setSelectedPhoneType(state, selectedPhoneType){
            state.selectedPhoneType = selectedPhoneType;
        },

        setAnswerDataTranscriptionSegmental(state, val){
            state.answerData.transcriptionSegmental[state.idxSelectedPhoneticInput] = val;
        },

        setAnswerDataDiacritic(state, diacritic){
            let selectedPhoneValue = state.answerData.transcriptionSegmental[state.idxSelectedPhoneticInput];

            let allowedVowels = state.transcriptionPhones.vowels.map(phone => phone.valuePhonetic);
            let allowedConsonants = state.transcriptionPhones.consonants.map(phone => phone.valuePhonetic);
            let allowedPhones = allowedVowels.concat(allowedConsonants);

            let allowedDiacritics = ['ʰ', '•', ':'];

            // Check if the selected phone index is not empty.
            if(selectedPhoneValue.length < 1){
                console.warn("VUEX/SET_ANSWER_DATA_DIACRITIC::EMPTY_SELECTED_PHONE");
                return;
            }
            
            // Check if the selected phone index has already a phone as the first character.
            if(!allowedPhones.includes(selectedPhoneValue[0])){
                console.warn("VUEX/SET_ANSWER_DATA_DIACRITIC::INV_FIRST_PHONE");
                return;
            }

            // Update selected phone index with the new diacritic.
            let updatedPhoneValue = selectedPhoneValue.charAt(0) + diacritic;
            state.answerData.transcriptionSegmental[state.idxSelectedPhoneticInput] = updatedPhoneValue;
        }

    },
    actions: {
    },
    modules: {
    },
    plugins: [updateLocalUserSession],
})
